import { createFileRoute } from "@tanstack/react-router";
import { PrintJobsPage } from "../features/printers/print-jobs-page";

/** More > Printers > Print jobs (P5-T26). Every role may look and retry. */
export const Route = createFileRoute("/more/printers/jobs")({ component: PrintJobsPage });
